import { logout } from "@/utils/identity";
import { isAppDiscoverable } from "@/utils/isIOS";
import { navigateTo } from "@/utils/navigation";
import { HiOutlineVideoCamera } from "react-icons/hi";
import { HiMiniDevicePhoneMobile } from "react-icons/hi2";
import { TbLogout } from "react-icons/tb";
import { NavItem } from "./types";

const MOBILE_APP_STORE_URL =
    "https://apps.apple.com/us/app/strawberry-me-coaching/id6751657658";

export function mobileAppNavItem(): NavItem {
    return {
        placement: "bar",
        icon: HiMiniDevicePhoneMobile,
        name: "Mobile App",
        visible: isAppDiscoverable(),
        onClick: () => window.open(MOBILE_APP_STORE_URL, "_blank"),
    };
}

export function videoTestNavItem(): NavItem {
    return {
        placement: "menu",
        icon: HiOutlineVideoCamera,
        name: "Video and Audio Test",
        onClick: () => navigateTo(route("video-test")),
        routeName: "video-test",
        selected: route().current() === "video-test",
    };
}

export function logOutNavItem(): NavItem {
    return {
        placement: "menu",
        icon: TbLogout,
        name: "Log Out",
        onClick: () => void logout(),
    };
}
